import { Component, input } from '@angular/core';

import { CsIconModule } from '@components/icon';

@Component({
  selector: 'processing-banner',
  imports: [
    CsIconModule
],
  templateUrl: './processing-banner.component.html',
})
export class ProcessingBannerComponent {
  readonly padding = input<string | undefined>(undefined);
  readonly margin = input<string | undefined>(undefined);
}
